import React from "react";
import Card from "./Card";

const font = '"DM Sans", sans-serif';

function KpiCard({ label, value, sub, icon, trend }) {
  return (
    <Card style={{ padding: "18px 20px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <div style={{ fontSize: 11, color: "#999999", fontFamily: font }}>{label}</div>
          <div style={{ fontSize: 24, fontWeight: 700, color: "#363636", marginTop: 4, fontFamily: font }}>
            {value}
          </div>
          <div
            style={{
              fontSize: 11,
              color:
                trend === "up" ? "#c1d850" : trend === "down" ? "#ff4b4f" : "#7a7a7a",
              marginTop: 2,
              fontFamily: font,
            }}
          >
            {sub}
          </div>
        </div>
        {icon && <span style={{ fontSize: 24, opacity: 0.4, color: "#363636" }}>{icon}</span>}
      </div>
    </Card>
  );
}

export default KpiCard;
